angular
	.module('exceptionHandlerOverride', [])
	.factory('$exceptionHandler', ['$log', 'ENVIRONMENT', function($log, ENVIRONMENT) {
		return function exceptionHandlerOverride(exception, cause) {
			$log.error(exception);
		};
	}]);
